import React, { useState, useEffect} from 'react';
import { useInView } from 'react-intersection-observer';
import CountUp from 'react-countup';
import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer} from 'recharts';
import dayjs from 'dayjs';
import { sendGetRequest } from '../../../Helper/helper'; 

const CoinChart = () => {
  const timeframes = {'1W': 7, '1M': 30, '3M': 90, '6M': 180, '1Y': 365, 'ALL': null };
  const isMobile = window.innerWidth < 767;
  const [timeframe, setTimeframe] = useState('3M');
  const [fullData, setFullData] = useState([]);
  const [lastMonthPrice, setLastMonthPrice] = useState(0);
  const [lastWeekPrice, setLastWeekPrice] = useState(0);
  const [yesterdayPrice, setYesterdayPrice] = useState(0);
  const [latestPrice, setLatestPrice] = useState(0);

  const filterData = () => {
    let filtered = timeframes[timeframe] === null ? fullData : fullData.filter(d => dayjs(d.date).isAfter(dayjs().subtract(timeframes[timeframe], 'day')));
    return filtered.sort((a, b) => new Date(a.date) - new Date(b.date));
  };

  const displayedData = filterData();

  useEffect(() => {
    fetchPriceData();
  }, []);

  const fetchPriceData = async () =>  {
    const response = await sendGetRequest('ptgc/historical/price', 'GET');
    if (response && response.status === 200) {
      setFullData(response.data);
      setLastMonthPrice(response.meta.last_month_price);
      setLastWeekPrice(response.meta.last_week_price);
      setYesterdayPrice(response.meta.yesterday_price);
      setLatestPrice(response.meta.latest_price);
    }
  };

  const AnimatedValue = ({ value }) => {
    const { ref, inView } = useInView({ triggerOnce: true });
    return (
      <h3 className="dollorValue value mb-0" ref={ref}>
        <span className="dollor">$</span>
        {inView && <CountUp end={value} duration={2.5} separator="," decimals={8} />}
      </h3>
    );
  };

  return (
    <section className="priceStats padsec PTGCSEC">
      <div className="container">
        <div className="priceStatsIn">
          <div className="d-flex justify-content-between align-items-center">
            <img src="./images/ptgc/logo.svg" className="img-fluid logoSmall" />
          </div>
          <div className="row mb-3">
         
            <div className="col-md-3">
              <div className="snUpdown mt-3" data-aos="fade" data-aos-delay="400" data-aos-duration="1000">
                <div className="d-flex gap-2 align-items-center">
                  <AnimatedValue value={yesterdayPrice} />
                  <i className="fa-solid fa-angle-up tgreen"></i>
                </div>
                <p className="mb-0 tGreen">Yesterday Price</p>
              </div>
            </div>

            <div className="col-md-3">
              <div className="snUpdown mt-3" data-aos="fade" data-aos-delay="400" data-aos-duration="1400">
                <div className="d-flex gap-2 align-items-center">
                  <AnimatedValue value={lastWeekPrice} />
                  <i className="fa-solid fa-angle-down tRed"></i>
                </div>
                <p className="mb-0 tGreen">Last Week Price</p>
              </div>
            </div>

            <div className="col-md-3">
              <div className="snUpdown mt-3" data-aos="fade" data-aos-delay="400" data-aos-duration="1800">
                <div className="d-flex gap-2 align-items-center">
                  <AnimatedValue value={lastMonthPrice} />
                  <i className="fa-solid fa-angle-up tgreen"></i>
                </div>
                <p className="mb-0 tGreen">Last Month Price</p>
              </div>
            </div> 
          </div>

          <div className="priceChart">
            <div>
              <div className='d-flex'>
                <div className='rTabs' style={{ marginBottom: 20 }}>
                  {Object.keys(timeframes).map(tf => (
                    <button key={tf} onClick={() => setTimeframe(tf)} style={{ marginRight: 8, padding: '6px 12px', background: timeframe === tf ? 'linear-gradient(94.35deg, #F8F192 0.05%, #E3D578 26.62%, #B18D38 56.99%, #9D721F 98.73%)' : '', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer' }}> {tf} </button>
                  ))}
                </div>
              </div>
              
              <div style={{marginLeft: '-20px'}}>
                <ResponsiveContainer width="100%" height={isMobile ? 200 : 300}>
                  <AreaChart data={displayedData}>
                    <defs>
                      <linearGradient id="colorArea" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor="#FFD700" stopOpacity={0.6} />
                        <stop offset="100%" stopColor="#121212" stopOpacity={0} />
                      </linearGradient>
                    </defs>
                    <XAxis dataKey="date" tick={{ fill: '#ccc' }} tickFormatter={date => dayjs(date).format('DD MMM, YYYY')}/>
                    <YAxis tick={{ fill: '#ccc' }} tickFormatter={(value) => value.toFixed(6)} />
                    <Tooltip
                      contentStyle={{ backgroundColor: '#333', border: 'none' }}
                      labelStyle={{ color: '#fff' }}
                      formatter={(value) => [`$${parseFloat(value).toFixed(8)}`, 'Price']}
                      labelFormatter={(label) => dayjs(label).format('D MMM, YYYY')}
                    />
                    <Area type="monotone" dataKey="value" stroke="#DCA83D" fillOpacity={1} fill="url(#colorArea)"/>
                  </AreaChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CoinChart;
